export default {
      id: "corporate_fare-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#corporate_fare",
      toString: function () {
        return this.url;
      }
    }